export const useMaxContentWidth = (): string | undefined => {
  return undefined;
};
